export const CARD_MARGIN = 40;
export const CARD_MARGIN_MOBILE = 20;
export const TITLE_FOR_CUSTOM_COLORS = 'Limitations';
